module.exports = __webpack_public_path__ + "static/media/report_action_items.b5522369.svg";